import React, { Component } from 'react';
import { Card, Breadcrumb, ButtonGroup, Button, Alert } from 'react-bootstrap';
import RevisionDetailsView from 'components/controls/RevisionDetailsView/index';
import QueryView from './query';
import PreviewView from './preview';

export default class ExplorePane extends Component {
  render() {
    return (
      <>
        <Card>
          <Card.Header>
            {this.props.revision
              ? <RevisionDetailsView
                  app={this.props.app}
                  blob={this.props.blob}
                  revision={this.props.revision}
                  shell={this.props.shell}
                />
              : <Alert variant="primary" className="mb-0">Loading revision info...</Alert>
            }
          </Card.Header>
          <Card.Body>
            <QueryView
              app={this.props.app}
              blob={this.props.blob}
              revision={this.props.revision}
              shell={this.props.shell}
            />
            <hr/>

            <PreviewView
              app={this.props.app}
              blob={this.props.blob}
              revision={this.props.revision}
              shell={this.props.shell}
            />
          </Card.Body>
        </Card>
      </>
    );
  }
}
